export default "__VITE_ASSET__9Y7WCdWO__"